/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useEffect, useRef } from "react";
import { cn } from "tailwind-variants";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { isProduction } from "common/utils/env";
import { readCookie } from "common/utils/cookie";
import { api } from "jiffy-api";
import { useDtfStore } from "../store";
import "./GangSheetBuilderButton.scss";

const INCHES_TO_FEET = 12;

export default function GangSheetBuilderButton({ ...restProps }) {
  const dtfStore = useDtfStore();
  const dtfStoreRef = useRef(dtfStore);
  dtfStoreRef.current = dtfStore;

  function gangSheetBuilderSettings() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilderSettings' comes from an ... Remove this comment to see the full error message
    return dtfStore.gangSheetBuilderSettings;
  }

  function gangSheetBuilder() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilder' comes from an index si... Remove this comment to see the full error message
    return dtfStore.gangSheetBuilder;
  }

  function gangSheetBuilderShopId() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilderShopId' comes from an in... Remove this comment to see the full error message
    return dtfStore.gangSheetBuilderShopId;
  }

  function gangSheetBuilderVariants() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilderVariants' comes from an ... Remove this comment to see the full error message
    return dtfStore.gangSheetBuilderVariants;
  }

  function gangSheetBuilderSizes() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilderSizes' comes from an ind... Remove this comment to see the full error message
    return dtfStore.gangSheetBuilderSizes;
  }

  function gangSheetBulkPrice() {
    // @ts-expect-error TS(4111): Property 'gangSheetBulkPrice' comes from an index ... Remove this comment to see the full error message
    return dtfStore.gangSheetBulkPrice;
  }

  function preloadedDesignId() {
    // @ts-expect-error TS(4111): Property 'preloadedDesignId' comes from an index s... Remove this comment to see the full error message
    return dtfStore.preloadedDesignId;
  }

  function catalogNumber() {
    // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
    return dtfStore.catalogNumber;
  }

  function gangSheetBuilderSizesAndVariants() {
    const gangSheetBuilderSizesAndVariants: any = []; // eslint-disable-line no-shadow
    let sizeId = 1;
    // @ts-expect-error TS(2769): No overload matches this call.
    Object.entries(gangSheetBuilderVariants()).forEach(([label, variant]) => {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      gangSheetBuilderSizes().forEach((size: any) => {
        gangSheetBuilderSizesAndVariants.push({
          ...size,
          title: `${label} - ${size.height / INCHES_TO_FEET} Feet`,
          metadata: {
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            variantId: variant.variant_id
          },
          id: sizeId
        });
        sizeId += 1;
      });
    });
    return gangSheetBuilderSizesAndVariants;
  }

  function selectedSize() {
    return gangSheetBuilderSizesAndVariants().find(
      // @ts-expect-error TS(7006): Parameter 'size' implicitly has an 'any' type.
      size =>
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        size.height === gangSheetBuilderSettings().height &&
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        size.metadata.variantId === gangSheetBuilderSettings().variantId
    );
  }

  function builderPayload() {
    const payload = {
      container: "gs-builder",
      // @ts-expect-error TS(2774): This condition will always return true since this ... Remove this comment to see the full error message
      mode: isProduction ? "production" : "development",
      shop_id: gangSheetBuilderShopId(),
      size_id: selectedSize().id,
      sizes: gangSheetBuilderSizesAndVariants(),
      settings: {
        nameAndNumber: {
          enabled: true
        }
      }
    };
    const customerId = readCookie("gangsheet_builder_customer_id");
    if (customerId) {
      // @ts-expect-error TS(2339): Property 'customer' does not exist on type '{ cont... Remove this comment to see the full error message
      payload.customer = {
        id: customerId
      };
    }
    return payload;
  }

  function setLoadedArtwork(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.setLoadedArtwork(...args);
  }

  function setPreloadedDesignId(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.setPreloadedDesignId(...args);
  }

  function submitForm(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.submitForm(...args);
  }

  function showBuilder() {
    submitDtfEvent("gangsheet_builder_opened", {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      size: Math.ceil(gangSheetBuilderSettings().height / 12.0),
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      variant: gangSheetBuilderSettings().variantId
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    gangSheetBuilder()
      .open(builderPayload())
      .on("design:created", async (gangSheetData: any) => {
        const { designs } = gangSheetData.data;
        await addToCartGangSheet(designs);
      })
      .on("closed", () => {});
  }

  async function handleDesignUpdated(gangSheetData: any) {
    const { designs } = gangSheetData.data;
    designs.forEach((design: any) => {
      if (!design.size.metadata)
        design.size.metadata = {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          variantId: dtfStoreRef.current.gangSheetBuilderSettings.variantId
        };
    });
    await addToCartGangSheet(designs);
  }

  function editGangSheet() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    gangSheetBuilder()
      .open({
        ...builderPayload(),
        shop_id: gangSheetBuilderShopId(),
        design_id: preloadedDesignId()
      })
      .on("design:updated", handleDesignUpdated);
  }

  async function addToCartGangSheet(designs: any) {
    const response = await api.dtf.addToCartGangSheet({
      gang_sheet_data: designs,
      catalog_number: catalogNumber()
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    gangSheetBuilder().close();
    response.artworks.forEach((artwork: any, index: any) => {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const bulkPrice = gangSheetBulkPrice()[artwork.variant_id]?.bulk_price;
      let gangsheetPrice = bulkPrice?.find(
        (size: any) => size.height === artwork.height * artwork.quantity
      );
      // @ts-expect-error TS(2769): No overload matches this call.
      const selectedVariant = Object.values(gangSheetBuilderVariants()).find(
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        variant => variant.variant_id === artwork.variant_id
      );
      gangsheetPrice ||= bulkPrice[bulkPrice.length - 1];
      artwork.pricing = {
        unitPrice: gangsheetPrice.size_price * Math.ceil(artwork.height / 12.0)
      };
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      artwork.catalogNumber = selectedVariant.catalog_number;
      artwork.fromGangSheetBuilder = true;
      setLoadedArtwork({
        artwork,
        index
      });
    });
    submitForm();
  }

  useEffect(() => {
    if (preloadedDesignId()) {
      editGangSheet();
      setPreloadedDesignId(null);
    }
    return () => {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const builder = dtfStoreRef.current.gangSheetBuilder;
      if (builder) {
        // @ts-expect-error TS(2339): Property 'off' does not exist on type '{}'.
        builder.off("design:updated", handleDesignUpdated);
      }
    };
  }, []);

  return (
    // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
    <div {...restProps} className={cn("gang-sheet-builder-button", restProps.className)}>
      <button
        className="gang-sheet-builder-button__button"
        type="button"
        onClick={e => {
          e.stopPropagation();
          showBuilder();
        }}
        data-testid="gang-sheet-builder-button-button"
      >
        {" "}
        Build Your Gang Sheet{" "}
      </button>
    </div>
  );
}
